import type { ReactNode } from "react";
import { ArrowLeftIcon } from "@/components/icons";
import { Button } from "@/components/kit";

type ProductFormPageHeaderProps = {
  title: string;
  subtitle?: string;
  onBack: () => void;
  actions?: ReactNode;
};

export function ProductFormPageHeader({
  title,
  subtitle,
  onBack,
  actions,
}: ProductFormPageHeaderProps) {
  return (
    <div className="mb-6 flex min-w-0 flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <h2 className="break-all font-display text-2xl text-foreground sm:text-3xl">
          {title}
        </h2>
        {subtitle ? (
          <p className="break-all text-muted-foreground text-sm">{subtitle}</p>
        ) : null}
        <div className="mt-2 h-0.5 w-16 shrink-0 rounded-full bg-secondary/70" />
      </div>
      <div className="flex shrink-0 flex-wrap items-center gap-2">
        {actions}
        <Button
          variant="outline"
          className="rounded-full border-secondary/40"
          onClick={onBack}
        >
          <ArrowLeftIcon data-icon="inline-start" />
          ກັບຄືນ
        </Button>
      </div>
    </div>
  );
}
